import type { ReactNode } from 'react'
import { useStyles } from './styles'
import { SwipeableDrawer } from '@mui/material'
import { DefaultTransactionHeader } from './defaultHeader'
import { DefaultTransactionContent } from './defaultContent'
interface TransactionDrawerProps {
  open: boolean
  onClose: () => void
  onOpen: () => void
  header: ReactNode
  content: ReactNode
}

export const TransactionDrawer = ({
  open,
  onClose,
  onOpen,
  header = <DefaultTransactionHeader />,
  content = <DefaultTransactionContent />,
}: TransactionDrawerProps) => {
  const { classes } = useStyles()

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      className={classes.drawer}
      disableSwipeToOpen
    >
      <div className={classes.header}>{header}</div>
      <div className={classes.content}>{content}</div>
    </SwipeableDrawer>
  )
}
